import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import Card from "./../Card/Card"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Product.css";
import InnerBanner from '../InnerBanner';

function Product() {
    const featureProducts = useSelector(state => state.Products)
    return (
        <React.Fragment>
            <Helmet>
          		<title>Products | Kalinga Testing Instruments Pvt Ltd</title>
         		<meta
					name="description"
					content="Kalinga Testing Instruments Pvt Ltd is a Distributor, Importer and Exporter of scientific and laboratory equipment."
				/>
				<meta
					name="keywords"
					content="Kalinga Testing Instruments Pvt Ltd, DeFelsko Inspection Instruments in India, Kalinga Testing Instruments, defelsko Authorized Distributors, Wagner Meters Authorized Distributors, Delmhorst Authorized Distributors, Delmhorst Moisture Meter Distributor, Defelsko PosiTector Distributor"
				/>
        	</Helmet>
            <InnerBanner data="Products" />
            <div className="wrapper-main">
                <div className="container py-4">
                    <div className="row py-4">
                        {
                            featureProducts.products.map((product) =>
                                <Card data={product} key={product.sku} />
                            )
                        }
                    </div>
                </div>

                <div className="touch-line">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <p>
                                Kalinga Testing Instruments Pvt Ltd is proud to announce being ISO 9001:2015 certified recently and would like to thank you for your believe in us and our work. 
                                Our decision to become ISO 9001:2015 certified, demonstrates a commitment to provide quality instruments and services to our customers.
                               </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Product;